// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonalSettingPage_wrapper__j7Bj3","pin":"PersonalSettingPage_pin__aFTYl"};